export default __webpack_public_path__ + "static/media/reports.63bf270c.png";